import './App.css';
import React from 'react';
import LoginForm from './Components/LoginForm/LoginForm';
import HomePage from './Components/Protected-Pages/HomePage';
import Calender from './Components/Protected-Pages/Calender';
import Projects from './Components/Protected-Pages/projects';
import Items from './Components/Protected-Pages/Items';
import Tools from './Components/Protected-Pages/tools';
import Request from './Components/Protected-Pages/Purchase-req';
import ProjReq from './Components/Protected-Pages/ProjReq';
import Booking from './Components/Protected-Pages/booking';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import PrivateRoutes from './privateRoute';
import AdminRoutes from './AdminRoute';
import { AuthContextProvider } from './authContext';
import MainPage from './Components/mainpage';
import Admin_bR from './Components/Assets/Admin/bookingReq';
import Admin_request from './Components/Assets/Admin/Requests';
import ManageUsers from './Components/Assets/Admin/manage';
import Tasks from './Components/Assets/Admin/task';
import Progress from './Components/Assets/Admin/progress';
import LeaderRoutes from './LeaderRoute'
function App() {
  return ( 
    <AuthContextProvider>
      <Router>
        <Routes>
          <Route path='/login' element={<LoginForm/>}/>
          <Route path='/' element={<MainPage/>}/>
          
          <Route element={<PrivateRoutes/>}>
              <Route path='/home' element={<HomePage/>} />
              <Route path='/calender' element={<Calender/>} />
              <Route path='/projects' element={<Projects/>} />
              <Route path='/items' element={<Items/>} />
              <Route path='/tools' element={<Tools/>} />
              <Route path='/request' element={<Request/>} />
              <Route path='/Booking' element={<Booking/>} />
              <Route path='/ProjReq' element={<ProjReq/>}/>
              <Route element={<AdminRoutes/>}>
                <Route path='/manageUsers' element={<ManageUsers/>}/>
                <Route path='/progress' element={<Progress/>}/>
              </Route>    
              <Route element={<LeaderRoutes/>}>
                <Route path='/admin' element={<Admin_request/>} />
                <Route path='/viewBooking' element={<Admin_bR/>} />
                <Route path='/tasks' element={<Tasks/>}/>
              </Route>            
          </Route>
        </Routes>
      </Router>  
    </AuthContextProvider>
    
  );
}

export default App;

